module.exports = __webpack_public_path__ + "img/a5.2f48e2d8.png";